/* Footer app links are desktop-only. Do not scan, clone, or observe the header on mobile. */
if (!customElements.get('ki-footer-shared-apps')) {
  customElements.define('ki-footer-shared-apps', class extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 768px)');
      this.onViewportChange = () => this.updateMode();
      this.desktop.addEventListener('change', this.onViewportChange);
      this.onThemeLoad = (event) => { if (event.target?.querySelector?.('.ki-header') || event.target?.matches?.('.ki-header')) this.queueSync(); };
      document.addEventListener('shopify:section:load', this.onThemeLoad);
      this.updateMode();
    }
    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.onViewportChange);
      document.removeEventListener('shopify:section:load', this.onThemeLoad);
      this.visibilityObserver?.disconnect();
      this.headerObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
    updateMode() {
      this.visibilityObserver?.disconnect();
      this.headerObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.hidden = true;
      if (!this.desktop.matches) {
        this.querySelector('[data-ki-footer-apps-grid]')?.replaceChildren();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        this.sync();
        return;
      }
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        this.visibilityObserver.disconnect();
        this.sync();
      }, { rootMargin: '600px 0px' });
      this.visibilityObserver.observe(this.closest('.ki-footer') || this);
    }
    queueSync() {
      if (!this.desktop?.matches) return;
      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
        this.visibilityObserver = null;
      }
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.sync());
    }
    sync() {
      if (!this.desktop?.matches || !this.isConnected) return;
      const destination = this.querySelector('[data-ki-footer-apps-grid]');
      if (!destination) return;
      const grids = Array.from(document.querySelectorAll('.ki-header .ki-mega-menu-grid'));
      let source = null;
      let largest = -1;
      for (const grid of grids) {
        const count = grid.querySelectorAll('.ki-mega-menu-item').length;
        if (count > largest) { largest = count; source = grid; }
      }
      if (!source) {
        destination.replaceChildren();
        this.hidden = true;
        return;
      }
      const fragment = document.createDocumentFragment();
      let count = 0;
      for (const child of source.children) {
        if (!child.classList.contains('ki-mega-menu-category') && !child.classList.contains('ki-mega-menu-column')) continue;
        const clone = child.cloneNode(true);
        if (clone.classList.contains('ki-mega-menu-column')) clone.classList.add('ki-footer-shared-app-column');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('.ki-mega-menu-item').forEach(el => {
          el.classList.add('ki-footer-shared-app-item');
          count++;
        });
        fragment.appendChild(clone);
      }
      destination.replaceChildren(fragment);
      this.hidden = count === 0;
      const header = source.closest('.shopify-section') || source;
      if (this.observedHeader !== header) {
        this.headerObserver?.disconnect();
        this.observedHeader = header;
        this.headerObserver = new MutationObserver(() => this.queueSync());
        this.headerObserver.observe(header, { childList: true, subtree: true });
      }
    }
  });
}
